import axios from 'axios';

export const getBearerToken = () => localStorage.getItem('token');

export const getRestClient = () => axios.create({
  headers: {
    Authorization: getBearerToken(),
  },
});
